import { api } from '../api';
import { aplicarEsquema, aplicarTabela, deveRebuscarNpcs, tabelaAtual, type TabelaCombate } from './combateTabela';
import { aplicarMagiasDaTabela } from './magias';

let etagLocal = '';

export function etagAtual(): string {
  return etagLocal;
}

export function registrarEtag(novo: string): { primeira: boolean; mudou: boolean } {
  const anterior = etagLocal;
  const primeira = !anterior;
  const mudou = deveRebuscarNpcs(anterior, novo);
  etagLocal = novo;
  return { primeira, mudou };
}

export async function receberMundo(
  etag: string,
  esquema: number,
  hooks: {
    avisar: () => void;
    recarregarNpcs: (etag: string) => void;
  }
): Promise<void> {
  aplicarEsquema(esquema, () => { location.reload(); }, hooks.avisar);
  if (!etag) return;
  const { primeira, mudou } = registrarEtag(etag);
  let usado = etag;
  if (primeira || mudou) {
    try {
      const r = await api.tabelaCombate(etag);
      usado = r.etag || etag;
      if (r.etag && r.etag !== etag) registrarEtag(r.etag);
      aplicarTabela(r.tabela);
      aplicarMagiasDaTabela(tabelaAtual());
    } catch {
      /* a tabela anterior (ou o padrão do bundle) segura a tela */
    }
  }
  if (mudou) hooks.recarregarNpcs(usado);
  if (primeira || mudou) {
    window.dispatchEvent(new CustomEvent('uoidle-mundo', { detail: usado }));
  }
}

export type { TabelaCombate };
